import { render, staticRenderFns } from "./ButtonAICompHandler.vue?vue&type=template&id=5e356352&scoped=true"
import script from "./ButtonAICompHandler.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonAICompHandler.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ButtonAICompHandler.vue?vue&type=style&index=0&id=5e356352&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e356352",
  null
  
)

export default component.exports